module.exports = __webpack_public_path__ + "static/media/08-Darmstadt@3x.13eaf8c0.jpg";